import { createStore } from "redux";
import StateReducer from "./reducers";

const loadState = () => {
	try {
    const serializedState = localStorage.getItem('state');
  
		if (!serializedState) {
			return {
				category: '',
        url: window.location.pathname,
        shopUid: '',
        userName: '',
        paykuToken: '',
        products: {},
        data: [],
        shoppingCart: [],
        footerItem: {
          categories: 1,
          aboutUs: 0,
          shoppingCart: 0
        }
            }
          }
    return JSON.parse(serializedState);
    
    } 
    catch (err) {
      return {
        category: '',
        url: window.location.pathname,
        shopUid: '',
        userName: '',
        paykuToken: '',
        products: {},
        data: [],
        shoppingCart: [],
        delivery: '',
        footerItem: {
          categories: 1,
          aboutUs: 0,
          shoppingCart: 0
        }
          }
      }
};

const saveState = (state) => {
	try {
	  const serializedState = JSON.stringify(state);
	  localStorage.setItem('state', serializedState);
	} catch {
	  // ignore write errors
	}
  };

const initialData = loadState()

// const initialData = { 
//   category: '',
//   url: window.location.pathname,
//   shopUid: '',
//   userName: '',
//   products: {},
//   data: []
// }

const store = createStore(StateReducer, initialData);

store.subscribe(function() {
	saveState(store.getState())
});

export default store;
